import {Article} from "./article";
import {PricingItem} from "./pricing-item";

export class PackPricingItem extends PricingItem{

    constructor(public readonly device?: Article) {
        super();
    }

}